import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';

export function dateInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
    // Migrated from AngularJS https://raw.githubusercontent.com/Ins87/angular-date-interceptor/master/src/angular-date-interceptor.js
    let iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

    return next(request).pipe(
        tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                const body = event.body;
                convertToDate(body);
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                }
            }
        })
    );

    function convertToDate(body: any) {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (isIso8601(value)) {
                body[key] = new Date(value);
            } else if (value && typeof value === 'object') {
                convertToDate(value);
            }
        }
    }

    function isIso8601(value: any) {
        if (value === null || value === undefined) {
            return false;
        }

        return iso8601.test(value);
    }
}